import datafox from "../../img/datafoxStrona.png";
import React from "react";
import { All, Button, LP, PP } from "./Style";
export default function Datafox() {
  return (
    <All>
      <LP zrodlo={datafox}></LP>
      <PP>
        <h1>Datafox.pl</h1>
        <p>
          Strona internetowa dla lokalnego Tarnogórskiego biznesu. Zrobiona w
          Wordpressie z customowymi elementami na przełomie 09.2021 do 4.2022
        </p>
        <a target="_blank" rel="noopener noreferrer" href="https://datafox.pl">
          <Button>Zobacz</Button>
        </a>
      </PP>
    </All>
  );
}
